import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import WorkflowContainer from '../components/Workflows/WorkflowContainer';

class Workflows extends React.Component {

  componentDidMount = () => {
    this.props.log('Workflows.js/componentDidMount');
  }

  render() {
    return (<Container fluid={true}>
      <WorkflowContainer {...this.props} />
    </Container>
    );
  }
}

export default Workflows;